import { render, staticRenderFns } from "./RootNodeConfig.vue?vue&type=template&id=f7f7666a&scoped=true"
import script from "./RootNodeConfig.vue?vue&type=script&lang=js"
export * from "./RootNodeConfig.vue?vue&type=script&lang=js"
import style0 from "./RootNodeConfig.vue?vue&type=style&index=0&id=f7f7666a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f7666a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7f7666a')) {
      api.createRecord('f7f7666a', component.options)
    } else {
      api.reload('f7f7666a', component.options)
    }
    module.hot.accept("./RootNodeConfig.vue?vue&type=template&id=f7f7666a&scoped=true", function () {
      api.rerender('f7f7666a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/process/config/RootNodeConfig.vue"
export default component.exports